import React from "react";
import useAdminFormStats from "../hooks/useAdminFormStats";
import AdminFormStats from "../components/AdminFormStats";

const AdminFormStatsInterface = function (props) {
  const {
    stats,
    superUser,
    periodType,
    startDate,
    endDate,
    appliedFilters,
    onPeriodTypeChange,
    onStartDateChange,
    onEndDateChange,
    onApplyFilters,
    onRefreshData,
  } = useAdminFormStats(props);

  return (
    <AdminFormStats
      stats={stats}
      superUser={superUser}
      periodType={periodType}
      startDate={startDate}
      endDate={endDate}
      appliedFilters={appliedFilters}
      onPeriodTypeChange={onPeriodTypeChange}
      onStartDateChange={onStartDateChange}
      onEndDateChange={onEndDateChange}
      onApplyFilters={onApplyFilters}
      onRefreshData={onRefreshData}
    />
  );
};

export default AdminFormStatsInterface;
